var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLitlink = function SvgLitlink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Litlink_svg__a)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.76 19.754H0V4.086h2.397V16.48a.86.86 0 0 0 .25.6.842.842 0 0 0 .597.246h5.517v2.428ZM12.802 15.669h-2.396V3.274a.862.862 0 0 0-.25-.602.843.843 0 0 0-.598-.25H4.042V0h8.76v15.669Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Litlink_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v20H0z"
  })))));
};
export default SvgLitlink;